import { api } from '../rtk';
import { ENDPOINTS } from '../url';
import { NotificationsApiResponse } from '../../types/types';

export const notificationsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getNotifications: builder.query<NotificationsApiResponse, { page?: number; limit?: number; search?: string }>({
            query: ({ page = 1, limit = 5, search = '' }) => ({
                url: `${ENDPOINTS.NOTIFICATIONS_INBOX}?search=${search}&page=${page}&limit=${limit}`,
                method: 'GET',
            }),
            providesTags: ['Notifications'],
        }),
        markNotificationAsRead: builder.mutation({
            query: (notificationId: string) => ({
                url: `${ENDPOINTS.NOTIFICATIONS}/${notificationId}/read`,
                method: 'PUT',
            }),
            invalidatesTags: ['Notifications'],
        }),
        bulkMarkAsRead: builder.mutation({
            query: () => ({
                url: `${ENDPOINTS.NOTIFICATIONS}/bulk-mark-as-read`,
                method: 'PATCH',
            }),
            invalidatesTags: ['Notifications'],
        }),
    }),
});

export const { useGetNotificationsQuery, useMarkNotificationAsReadMutation, useBulkMarkAsReadMutation } = notificationsApi;

